module.exports = __webpack_public_path__ + "static/media/Vania Ramírez cv English.10bc27de.pdf";